import Super from 'client-portal/controllers/-request/confirmation';

export default class SiteRequestConfirmation extends Super {}
